module.exports = "/lucky-balls/img/drum/drum_loop_026.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_026.png
// module id = 1041
// module chunks = 0